

  /*
 * Green Box Shop
 * Desktop click-to-enlarge product gallery
 *
 * Replaces Warehouse's desktop Drift hover magnifier with the
 * existing PhotoSwipe lightbox already used by the theme on mobile.
 */


(() => {
  "use strict";

  const DESKTOP_QUERY = "(min-width: 1000px)";
  const POCKET_QUERY = "screen and (max-width: 1023px)";

  /**
   * Check whether this is the desktop gallery.
   */
  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  /**
   * Hide any Drift hover-zoom elements created by Warehouse.
   */
  function disableDriftZoom() {
    if (!isDesktop()) {
      return;
    }

    document
      .querySelectorAll(".drift-zoom-pane, .drift-bounding-box")
      .forEach((element) => {
        element.style.setProperty("display", "none", "important");
        element.style.setProperty("visibility", "hidden", "important");
        element.style.setProperty("opacity", "0", "important");
        element.style.setProperty("pointer-events", "none", "important");
      });

    document.querySelectorAll(".product-gallery__image").forEach((image) => {
      image.style.setProperty("cursor", "zoom-in", "important");
    });

    document
      .querySelectorAll(".product-gallery__zoom-notice")
      .forEach((notice) => {
        notice.style.setProperty("display", "none", "important");
      });
  }

  /**
   * Warehouse's PhotoSwipe function checks whether the viewport is
   * under 1024px before opening.
   *
   * During the desktop image click only, this temporarily makes that
   * one media query report true. Warehouse then runs its existing
   * PhotoSwipe code normally.
   */
  function enableDesktopPhotoSwipe(event) {
    if (!isDesktop()) {
      return;
    }

    const image = event.target.closest(".product-gallery__image");

    if (!image) {
      return;
    }

    const slide = image.closest(".product-gallery__carousel-item");

    if (!slide || slide.getAttribute("data-media-type") !== "image") {
      return;
    }

    const originalMatchMedia = window.matchMedia.bind(window);

    window.matchMedia = function patchedMatchMedia(query) {
      const result = originalMatchMedia(query);

      if (query === POCKET_QUERY) {
        return {
          matches: true,
          media: result.media,
          onchange: result.onchange,
          addListener:
            typeof result.addListener === "function"
              ? result.addListener.bind(result)
              : () => {},
          removeListener:
            typeof result.removeListener === "function"
              ? result.removeListener.bind(result)
              : () => {},
          addEventListener:
            typeof result.addEventListener === "function"
              ? result.addEventListener.bind(result)
              : () => {},
          removeEventListener:
            typeof result.removeEventListener === "function"
              ? result.removeEventListener.bind(result)
              : () => {},
          dispatchEvent:
            typeof result.dispatchEvent === "function"
              ? result.dispatchEvent.bind(result)
              : () => false
        };
      }

      return result;
    };

    /*
     * Restore matchMedia after Warehouse's delegated click handler
     * has opened PhotoSwipe.
     */
    window.setTimeout(() => {
      window.matchMedia = originalMatchMedia;
    }, 0);
  }

  /**
   * Prevent the visible Drift magnifier from returning when Warehouse
   * adds its elements dynamically.
   */
  function watchForDriftElements() {
    const observer = new MutationObserver(() => {
      disableDriftZoom();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    disableDriftZoom();
    watchForDriftElements();

    /*
     * Capture phase means the media-query patch is applied before
     * Warehouse receives the image click.
     */
    document.addEventListener("click", enableDesktopPhotoSwipe, true);

    document.addEventListener("shopify:section:load", () => {
      disableDriftZoom();
    });

    window.addEventListener("resize", disableDriftZoom);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
